/* eslint-disable linebreak-style */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';

import { Fade } from 'react-awesome-reveal';

export default function Service({ data }) {
  return (
    <div className="bg-gray-50">
      <div className="container mx-auto pt-20 pb-28">
        <Fade direction="right" triggerOnce>
          <h1 className="text-5xl text-theme-blue text-center font-bold">Dịch vụ</h1>
        </Fade>
        <Fade direction="left" triggerOnce>
          <p className="font-light text-lg text-gray-400 text-center mb-12">
            Với kinh nghiệm phong phú, NEWTECH mang đến cho khách hàng các giải pháp toàn diện trong 
            nhiều lĩnh vực với việc đồng hành cùng khách hàng từ giai đoạn tư vấn, 
            ý tưởng, phân tích yêu cầu, tới các giai đoạn thiết kế, kiểm thử cho 
            đến khi hoàn thiện sản phẩm và vận hành hệ thống 24/24.
          </p>
        </Fade>

        <div className="grid grid-rows-3 px-10 gap-8 sm:grid-cols-3 sm:grid-rows-1 sm:gap-6 xl:gap-16">
          {
            data.map((item, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Fade direction={item.animation} delay={500 * index} key={index} triggerOnce>
                <div>
                  <div className="bg-white group rounded-2xl shadow-2xl border border-light-theme-purple transform transition duration-500 hover:scale-105">
                    <img src={item.imageUrl} alt="Service" className="w-full rounded-t-2xl" />
                    <h2 className="text-theme-blue text-center text-xl py-7 rounded-b-2xl">{item.title}</h2>
                    <div className="absolute inset-x-0 bottom-0 h-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 group-hover:h-full group-hover:opacity-100 transition-all duration-500 rounded-2xl">
                      <p className="text-white text-center px-4 font-semibold text-justify">{item.description}</p>
                    </div>
                  </div>
                </div>
              </Fade>
            ))
          }
        </div>
      </div>
    </div>
  );
}
